export default function hasSameOrigin(url: string | undefined) {
  if (typeof window === "undefined" || !url) return false;

  try {
    const current_hostname = window.location.hostname;
    const link_url = new URL(url);
    const link_hostname = link_url?.hostname;

    return Boolean(current_hostname === link_hostname);
  } catch (err) {
    return true;
  }
}
